// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_J5nbf","secondaryColumnCell":"secondary-column-cell_J5nbf","titleContainer":"titleContainer_ZeXK8","title":"title_Rd613"};